<ng-container *transloco="let t">
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingEntity') }}</div>
    <div class="order-section-item-value">{{ billingEntity() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingVatCondition') }}</div>
    <div class="order-section-item-value">{{ vatCondition() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingName') }}</div>
    <div class="order-section-item-value">{{ billingInformation()?.name }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingDocument') }}</div>
    <div class="order-section-item-value">
      {{ documentType() }} - {{ billingInformation()?.documentNumber }}
    </div>
  </div>

  @if (adminMode()) {
    @if (!taxVoucherBilled()) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.billingTitle') }}</div>
        <div class="order-section-item-value">
          <pxw-button
            style="margin-left: 10px"
            size="sm"
            [rounded]="true"
            display="inline"
            color="yellow"
            [loading]="generatingTaxVoucher()"
            (click)="onGenerateTaxVoucher()"
          >
            {{ t('orderDetails.generateTaxVoucher') }}
          </pxw-button>
        </div>
      </div>
    }

    @let taxVoucher = orderDetails().taxVoucher;

    @if (taxVoucher) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.taxVoucher') }}</div>
        <div class="order-section-item-value">
          <div style="display: flex; align-items: center; gap: 10px">
            <app-order-details-tax-voucher-actions [taxVoucher]="taxVoucher" />
          </div>
        </div>
      </div>
    }
  }
</ng-container>
